"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fields = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const notification_api_1 = require("../notification/notification-api");
const form_editor_1 = require("../../composite/form/fields/form-editor");
const form_panel_1 = require("../../composite/form/fields/form-panel");
const form_select_1 = require("../../composite/form/fields/form-select");
const form_text_field_1 = require("../../composite/form/fields/form-text-field");
const form_context_1 = require("../../composite/form/form-context");
const selector_1 = require("../../composite/form/selectors/selector");
const list_source_hook_1 = require("../../utils/list-source-hook");
const notification_rule_fields_1 = require("./notification-rule-fields");
function Fields() {
    const { setFieldValue } = (0, react_1.useContext)(form_context_1.FormContext);
    const { event, type } = (0, selector_1.useFormSelector)((data) => ({
        event: data.event,
        type: data.type,
    }));
    const types = (0, notification_api_1.useNotificationTypes)();
    const events = (0, notification_api_1.useNotificationEvents)();
    const allowedEvents = (0, list_source_hook_1.useStaticListSource)(type
        ? events.items.filter((event) => { var _a; return (_a = event.allowedTypes) === null || _a === void 0 ? void 0 : _a.includes(type); })
        : []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATES_PANEL_TITLE", defaultMessage: "Obecn\u00E9" }), expandable: false },
            react_1.default.createElement(form_select_1.FormSelect, { name: "type", source: types, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATESS_LABEL_TYPE", defaultMessage: "Typ" }), notifyChange: () => {
                    setFieldValue('event', undefined);
                }, valueIsId: true, required: true }),
            react_1.default.createElement(form_text_field_1.FormTextField, { name: "name", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATESS_LABEL_NAME", defaultMessage: "N\u00E1zev" }), required: true }),
            react_1.default.createElement(form_select_1.FormSelect, { name: "event", source: allowedEvents, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATESS_LABEL_EVENT", defaultMessage: "Ud\u00E1lost" }), disabled: !type, required: true }),
            react_1.default.createElement(form_text_field_1.FormTextField, { name: "subject", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATESS_LABEL_SUBJECT", defaultMessage: "P\u0159edm\u011Bt" }), required: true }),
            react_1.default.createElement(form_editor_1.FormEditor, { name: "content", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATESS_LABEL_CONTENT", defaultMessage: "Obsah" }), language: "html", required: true })),
        (event === null || event === void 0 ? void 0 : event.ruleApplicable) && (react_1.default.createElement(notification_rule_fields_1.NotificationRule, { prefix: "rule" }))));
}
exports.Fields = Fields;
//# sourceMappingURL=notification-template-fields.js.map